import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";

export const BRAND_KEY = "ergo_brand";
export const VARIANTS = {
  syne: { name: "Syne · Μπλε / Πορτοκαλί", font: "font-logo", text: "ergo", dot: true, bg: "#1e40af", accent: "#f59e0b", radius: 12, caps: false },
  grotesk: { name: "Space Grotesk · Σκούρο Πράσινο / Λάιμ", font: "font-logo2", text: "ERGO", dot: false, bg: "#064e3b", accent: "#a3e635", radius: 8, caps: true },
  fraunces: { name: "Fraunces · Navy / Χρυσό", font: "font-logo3", text: "Ergo", dot: false, bg: "#0f172a", accent: "#eab308", radius: 24, caps: false },
};

export const getVariant = () => VARIANTS[localStorage.getItem(BRAND_KEY)] || VARIANTS.syne;
export const setVariant = (k) => { localStorage.setItem(BRAND_KEY, k); window.dispatchEvent(new Event("brand-change")); };

export const useBrand = () => {
  const [v, setV] = useState(getVariant);
  useEffect(() => {
    const h = () => setV(getVariant());
    window.addEventListener("brand-change", h);
    return () => window.removeEventListener("brand-change", h);
  }, []);
  return v;
};

export const LogoMark = ({ size = 36, inverted = false, className, variant }) => {
  const v = variant || getVariant();
  const bg = inverted ? "#fff" : v.bg;
  const fg = inverted ? v.bg : "#fff";
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" className={cn("shrink-0", className)} aria-hidden="true">
      <rect width="48" height="48" rx={v.radius} fill={bg} />
      <path d="M36 24H14" stroke={fg} strokeWidth="5" strokeLinecap="round" />
      <path d="M36 24a12 12 0 1 0-3.5 8.5" stroke={fg} strokeWidth="5" strokeLinecap="round" fill="none" />
      <circle cx="35.5" cy="34.5" r="2.6" fill={v.accent} />
    </svg>
  );
};

export const Wordmark = ({ className, variant }) => {
  const v = variant || getVariant();
  return (
    <span className={cn(v.font, "font-extrabold leading-none", v.caps ? "tracking-[0.08em]" : "tracking-tight", className)}>
      {v.text}{v.dot && <span style={{ color: v.accent }}>.</span>}
    </span>
  );
};

export const Logo = ({ size = 36, dark = false, subtitle, className }) => {
  const v = useBrand();
  return (
    <div className={cn("flex items-center gap-3", className)} data-testid="app-logo">
      <LogoMark size={size} inverted={dark} variant={v} />
      <div className="min-w-0">
        <Wordmark variant={v} className={cn(size >= 44 ? "text-4xl" : "text-2xl", dark ? "text-white" : "text-slate-900 dark:text-white")} />
        {subtitle && <div className={cn("text-[10px] uppercase tracking-[0.2em] mt-0.5", dark ? "text-blue-200" : "text-slate-500")}>{subtitle}</div>}
      </div>
    </div>
  );
};
